import { Action, DataContainer, submitEventMerge, submitEvent } from '@otto-ec/tracking-bct';

export class Tracking {
    submitEventMerge(action: Action, generateId: boolean = false): void {
        const eventMergeId = this.createEventMergeId(generateId);
        submitEventMerge(eventMergeId, {}, action);
    }

    submitEvent(action: Action, labels: DataContainer = {}): void {
        submitEvent(labels, action);
    }

    private randomEventMergeId(): string {
        const validChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        const randomChar = () => validChars[Math.floor(Math.random() * validChars.length)];
        return Array.from({ length: 10 }, randomChar).join('');
    }

    private createEventMergeId(generateId: boolean): string {
        if (generateId) {
            return this.randomEventMergeId();
        }

        return this.getEventMergeId() ?? this.randomEventMergeId();
    }

    private getEventMergeId(): string | undefined {
        return document.querySelector<HTMLElement>('.or_js_eventMergeId')?.dataset.eventMergeId;
    }
}
